import Modal from "react-bootstrap/Modal";
import "./style.css";

function UOMView(props) {
  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          View UOM
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <div className="row gx-5 gy-2">
          <div className="col-md-12">
            <label className="fw-bold">UOM Name:</label>
            <div className="form-control-plaintext">{props.id?.plt_val}</div>
          </div>
          <div className="col-md-12 mt-3">
            <label className="fw-bold">Status:</label>
            <div className="form-control-plaintext">
              {props.id?.comp_id == null ? (
                <span className="badge text-bg-secondary">Default</span>
              ) : (
                <span
                  className={`badge text-bg-${
                    props.id?.is_active ? "success" : "danger"
                  }`}
                >
                  {props.id?.is_active ? "Active" : "In-Active"}
                </span>
              )}
            </div>
          </div>
          <div className="col-12 mt-4 text-end">
            <button
              className="branchModalCancel"
              onClick={props.hide}
              type="button"
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                float: "right",
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default UOMView;
